import React from 'react';
import {DataSourceTypeImage} from '../DataSourceSettings/DataSourceTypeImage';

const TypeImageColumn = ({feed}) => {
  const type = feed.data?.extension || feed.data?.platform || '';
  return (
    <td className="text-center">
      <div className="d-flex justify-content-center">
        <DataSourceTypeImage type={type} status={feed.status} size={'medium'}/>
      </div>
    </td>
  );
};

export default TypeImageColumn;
